
import React, { useContext, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { BsCheck } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { CompanyInfoContext, EventContext, LoaderContext } from '../../App';
import { EventType, LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY, LS_SELECTED_MAT_ISSUE_YEAR } from '../../core/constants/common';
import useDoubleMatHelper from '../../core/hooks/useDoubleMatHelper';
import MaterialIssueService from '../../core/service/MaterialIssueService';

const DoubleMatProgressWizard = ({ t, viewMode = 'HOME_PAGE', selectedYear }) => {
	const navigate = useNavigate();
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [stats, setStats] = useState({});
  	const { event, setEvent } = useContext(EventContext);
	const year = viewMode === 'HOME_PAGE' 
		? (selectedYear ? parseInt(selectedYear) : new Date().getFullYear())
		: (localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? new Date().getFullYear());
	const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsDat.profile.company.id;  
	const {
		isSurveyCompleted
	} = useDoubleMatHelper();
	const { companyInfo } = useContext(CompanyInfoContext);

	useEffect(() => {
		if (companyInfo?.id > 0) {
			const currentYear = viewMode === 'HOME_PAGE' 
				? (selectedYear ? parseInt(selectedYear) : new Date().getFullYear())
				: (localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? new Date().getFullYear());
			getStats(currentYear);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyInfo, selectedYear]);


  useEffect(() => {
    if (event.event !== EventType.DOUBLE_MAT_YEAR_CHANGED) return;

    // Reset event first
    setEvent({
      event: '',
      data: '',
      status: ''
    });
    getStats(event.data.year);
  }, [event]);

	const getStats = (y) => {
		setLoaderDisplay(true);
		const compInfoLS = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
		MaterialIssueService.getStats(companyId, y, compInfoLS?.materialTopicCategory ?? 'GENERAL').then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setStats(res.data);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};


	const getStakeholderClassName = () => {
		let totalWeightage = 0;
		if (stats?.stakeholder?.weightageDistribution) {
			Object.keys(stats.stakeholder.weightageDistribution)?.forEach(d => {
				totalWeightage += stats.stakeholder.weightageDistribution[d].weightage ?? 0;
			});

		}
		if (stats?.stakeholder?.totalStakeholders > 0 && totalWeightage >= 100) {
			return 'done';
		} else if (stats?.stakeholder?.totalStakeholders > 0 && totalWeightage < 100) {
			return 'active select';
		} else {
			return 'cursor';
		}
	};

	const getIssuesClassName = () => {
		if (stats?.issueProgress?.version?.status == 'FINALIZED'){
			return 'done';
		} else if (stats?.issueProgress?.version?.status == 'DRAFT') {
			return 'active select';
		} else  {
			return 'cursor';
		}
	};

	const getSurveyClassName = () => {
		if (isSurveyCompleted(stats)){
			return 'done';
		} else if (stats?.assessment) {
			return 'active select';
		} else  {
			return 'cursor';
		}		
	};

	const getScorecardClassName = () => {
		if (stats?.scorecard?.statusCounts?.FINALIZED > 0) {
			return 'done';
		} else if (stats?.scorecard?.statusCounts?.DRAFT > 0) {
			return 'active select';
		} else  {
			return 'cursor';
		}
	};

	const getReportClassName = () => {
		if (stats?.scorecard?.statusCounts?.REPORT_COUNT > 0) {
			return 'done';
		} else if ((stats?.scorecard?.statusCounts?.DRAFT + stats?.scorecard?.statusCounts?.FINALIZED) > 0) {
			return 'active select';
		} else  {
			return 'cursor';
		}
	}

	return (
		<div className={viewMode === 'HOME_PAGE' ? 'DoubleMateriality_StepHome no-border' : 'DoubleMateriality_wizard_lineBox'}>
			<ul>
				<li className={getStakeholderClassName()}
					onClick={() => navigate(`/company_admin/dmat/stakeholders`)}>
					<span className={viewMode === 'HOME_PAGE' ? 'number' : ''}>1</span>
					{viewMode === 'HOME_PAGE' && <span className='checkIcon'><BsCheck /></span>}
					{t("MapStakeholders.label")}
				</li>
				<li className={getIssuesClassName()}
					onClick={() => navigate(`/company_admin/dmat/issues`)}>
					<span className={viewMode === 'HOME_PAGE' ? 'number' : ''}>2</span>
					{viewMode === 'HOME_PAGE' && <span className='checkIcon'><BsCheck /></span>}
					{t("IdentifyMaterialIssues.label")}
				</li>
				<li className={getSurveyClassName()}
					onClick={() => navigate(`/company_admin/dmat/matassessments`)}>
					<span className={viewMode === 'HOME_PAGE' ? 'number' : ''}>3</span>
					{viewMode === 'HOME_PAGE' && <span className='checkIcon'><BsCheck /></span>}
					{t("ConductMaterialityAssessmentSurvey.label")}
				</li>
				<li className={getScorecardClassName()} onClick={() => navigate(`/company_admin/dmat/scorecard/default`)}>
					<span className={viewMode === 'HOME_PAGE' ? 'number' : ''}>4</span>
					{viewMode === 'HOME_PAGE' && <span className='checkIcon'><BsCheck /></span>}
					{t("FinalizeScoreCards.label")}
				</li>
				<li className={getReportClassName()} onClick={() => navigate(`/company_admin/dmat/report/list`)}>
					<span className={viewMode === 'HOME_PAGE' ? 'number' : ''}>5</span>
					{viewMode === 'HOME_PAGE' && <span className='checkIcon'><BsCheck /></span>}
					{t("DraftMaterialityReport.label")}
				</li>
			</ul>
		</div>
	);
}

export default withTranslation()(DoubleMatProgressWizard);